
const adminStickyHeaderMixin = {

    methods: {
        async fixStickyHeader(scrollTop) {
            try {
                var header = document.getElementsByClassName("top_filters_area")[0];
                if(header) {
                    var sticky = header.offsetTop;
                    if (scrollTop > sticky) {
                        header.classList.add("sticky");
                    } else {
                        header.classList.remove("sticky");
                    }
                }
            } catch (error) {
                console.log('error', error)
            }
        },
    }
};

export default adminStickyHeaderMixin;
